module.exports = __webpack_public_path__ + "static/media/22.b87cd27f.jpg";